import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconSalesOrders: React.FC<IconProps> = ({
  size = 19,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 19 18"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M13.6569 2.83557L9.71937 1.17001C9.65003 1.14079 9.57553 1.12573 9.50028 1.12573C9.42503 1.12573 9.35053 1.14079 9.28119 1.17001L5.34369 2.83557C5.24182 2.87843 5.15487 2.95039 5.09374 3.04245C5.0326 3.13451 4.99999 3.24256 5 3.35307V5.06251H4.4375C3.50712 5.06251 2.75 5.81964 2.75 6.75001V12.375C2.75 13.3054 3.50712 14.0625 4.4375 14.0625H7.12625L6.78875 15.75H5.5625C5.41332 15.75 5.27024 15.8093 5.16475 15.9148C5.05926 16.0203 5 16.1633 5 16.3125C5 16.4617 5.05926 16.6048 5.16475 16.7103C5.27024 16.8157 5.41332 16.875 5.5625 16.875H13.4375C13.5867 16.875 13.7298 16.8157 13.8352 16.7103C13.9407 16.6048 14 16.4617 14 16.3125C14 16.1633 13.9407 16.0203 13.8352 15.9148C13.7298 15.8093 13.5867 15.75 13.4375 15.75H12.2113L11.8737 14.0625H14.5625C15.4929 14.0625 16.25 13.3054 16.25 12.375V6.75001C16.25 5.81964 15.4929 5.06251 14.5625 5.06251H14V3.35307C14.0001 3.24263 13.9675 3.13462 13.9065 3.04257C13.8455 2.95051 13.7586 2.87851 13.6569 2.83557ZM9.5 2.29839L11.9941 3.35307L11.6341 3.50551L9.14 2.45082L9.5 2.29839ZM12.875 4.20189V7.52401L10.0625 8.7137V5.39214L12.875 4.20189ZM7.69662 3.06114L10.1908 4.11639L9.5 4.40832L7.00588 3.35364L7.69662 3.06114ZM6.125 4.20245L8.9375 5.39214V8.7137L6.125 7.52401V4.20245ZM7.93625 15.75L8.27375 14.0625H10.7268L11.0643 15.75H7.93625ZM14.5625 6.18751C14.873 6.18751 15.125 6.44007 15.125 6.75001V12.375C15.125 12.6849 14.873 12.9375 14.5625 12.9375H4.4375C4.127 12.9375 3.875 12.6849 3.875 12.375V6.75001C3.875 6.44007 4.127 6.18751 4.4375 6.18751H5V7.89695C5 8.12307 5.135 8.32726 5.34312 8.41501L9.28062 10.0806C9.35 10.1101 9.42461 10.1253 9.5 10.1253C9.57539 10.1253 9.65 10.1101 9.71937 10.0806L13.6569 8.41501C13.7586 8.37191 13.8454 8.29979 13.9065 8.20766C13.9675 8.11553 14 8.00746 14 7.89695V6.18751H14.5625Z" fill="currentColor"/>
  </svg>
);

export default IconSalesOrders;
